import Vue from 'vue'
import { mapState } from 'vuex'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import rolebleMixin from '@/mixins/rolebleMixin'
import snackMixin from '@/mixins/snackMixin'
import {
  applicationManageMixin,
  disputableMixin,
  doneGigJobManageMixin,
  gigJobPartiesMixin,
  offerManageMixin,
  payableMixin,
  refundableMixin,
  reportableMixin,
  reviewableMixin,
  startableMixin,
} from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [
    applicationManageMixin,
    disputableMixin,
    doneGigJobManageMixin,
    gigJobPartiesMixin,
    offerManageMixin,
    payableMixin,
    refundableMixin,
    reportableMixin,
    reviewableMixin,
    rolebleMixin,
    snackMixin,
    startableMixin,
  ],
  data() {
    return {
      canceling: false,
      donning: false,
    }
  },
  computed: {
    ...mapState({
      application: (state: any) => state.gigChat.application.value,
    }),
    hasAcceptOffer() {
      return this.application?.offer?.stage === GigOfferStages.NEW
    },
  },
  methods: {
    onDoneClick() {
      this.markGigJobAsDone()
    },
    onCancelGigDoneClick() {
      this.markGigJobAsNotDone()
    },
    onDeclineGigByFreelancerClick() {
      this.declineApplicationByFreelancer()
    },
    onDeclineGigByCustomerClick() {
      this.declineApplicationByCustomer()
    },
    onSendOfferClick() {
      this.createOffer()
    },
    async onDeclineOfferClick() {
      try {
        this.canceling = true
        await this.cancelOffer()
      } finally {
        this.canceling = false
      }
    },
    onAcceptClick() {
      this.acceptOffer()
    },
    onStartJobClick() {
      this.startJob()
    },
    onPayToTalentClick() {
      this.payToTalent()
    },
    onLeaveReviewClick() {
      this.leaveReview()
    },
    onReportClick() {
      this.reportUser()
    },
    onCreateDisputeClick() {
      this.createDispute()
    },
    onRefundClick() {
      this.refundToCustomer()
    },
  },
})
